// @ts-nocheck
import React, { useState, useMemo, useEffect } from "react";
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
} from "firebase/firestore";

// Importation du logo local
import logoLab from "./Archambault Lab.png";

/* eslint-disable react/prop-types, react/no-unescaped-entities */

const firebaseConfig = {
  apiKey: "AIzaSyDd-_Drp5LZO8E2SIVqyynAQYFNRf4vlSU",
  authDomain: "boite-a-outil-memoire.firebaseapp.com",
  projectId: "boite-a-outil-memoire",
  storageBucket: "boite-a-outil-memoire.firebasestorage.app",
  messagingSenderId: "48674409159",
  appId: "1:48674409159:web:fce188d094015e9ca5cce2",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

// --- Icônes ---
const SearchIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#013a5d"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{
      position: "absolute",
      left: "16px",
      top: "68%",
      transform: "translateY(-50%)",
      opacity: 0.5,
      pointerEvents: "none",
    }}
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);
const XIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#013a5d"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);
const TrashIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ef4444"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="3 6 5 6 21 6"></polyline>
    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
  </svg>
);
const EditIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#3f9ad3"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
  </svg>
);
const UploadIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#013a5d"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
    <polyline points="17 8 12 3 7 8"></polyline>
    <line x1="12" y1="3" x2="12" y2="15"></line>
  </svg>
);

// --- Taxonomies ---
const typologiesOutils = [
  "Soutien à la décision",
  "Soutien à la communication",
  "Systèmes et technologie",
  "Cadre éthique et juridique",
  "Communication et évaluation des risques",
  "Programmes de développement professionnel",
];
const categoriesTransitions = [
  "Annonce du diagnostic",
  "Progression de la maladie",
  "Changements de soins à domicile",
  "Changement du rôle de l'aidant",
  "Soins longue durée",
  "Hôpital et congé",
  "Planification préalable des soins",
];
const publicsCibles = [
  "Dyade – Usager et proche aidant",
  "Dyade – Usager et professionnel",
  "Dyade – Proche aidant et professionnel",
  "Professionnels seulement",
  "Triadique – Usager, proche aidant et professionnel",
  "Usager seulement",
  "Proches aidants seulement",
];
const langues = ["Français seulement", "Anglais seulement", "Bilingue"];

const criteriaRowStyle = {
  padding: "12px 14px",
  borderBottom: "1px solid #e2e8f0",
};

const criteriaCategoryStyle = {
  margin: "0 0 8px 0",
  color: "#334155",
  fontSize: "14px",
  fontWeight: "700",
};

const criteriaGridStyle = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "28px",
};

const includeStyle = {
  margin: "0 0 5px 0",
  color: "#15803d",
  fontSize: "12px",
  fontWeight: "700",
};

const excludeStyle = {
  margin: "0 0 5px 0",
  color: "#dc2626",
  fontSize: "12px",
  fontWeight: "700",
};

const criteriaListStyle = {
  margin: 0,
  paddingLeft: "18px",
  color: "#475569",
  fontSize: "12px",
  lineHeight: "1.45",
};

const criteriaTextStyle = {
  margin: 0,
  color: "#475569",
  fontSize: "12px",
  lineHeight: "1.45",
};
const normaliserTexte = (texte = "") =>
  String(texte)
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[’']/g, " ")
    .trim();
export default function App() {
  const [showCriteria, setShowCriteria] = useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  const [editingId, setEditingId] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [openLangChoiceId, setOpenLangChoiceId] = useState<string | null>(null);
  const [transitionFilter, setTransitionFilter] = useState("");
  const [typologyFilter, setTypologyFilter] = useState("");
  const [publicFilter, setPublicFilter] = useState("");
  const [langueFilter, setLangueFilter] = useState<string[]>([]);
  const [showLangueMenu, setShowLangueMenu] = useState(false);

  const [formData, setFormData] = useState({
    outilId: "",
    titre: "",
    transition1: "",
    transition2: "",
    typologie: "",
    publicCible: "",
    langue: "",
    description: "",
    lien: "",
    lienAnglais: "",
    auteur: "",
    annee: "",
    donneesProbantes: "",
    guideUtilisation: "",
    motsCles: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const snap = await getDocs(collection(db, "ressources"));
        setData(snap.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await updateDoc(doc(db, "ressources", editingId), formData);
        setData(
          data.map((item) =>
            item.id === editingId ? { ...formData, id: editingId } : item
          )
        );
      } else {
        const docRef = await addDoc(collection(db, "ressources"), formData);
        setData([{ ...formData, id: docRef.id }, ...data]);
      }
      setIsAdding(false);
      setEditingId(null);
      setFormData({
        outilId: "",
        titre: "",
        transition1: "",
        transition2: "",
        typologie: "",
        publicCible: "",
        langue: "",
        description: "",
        lien: "",
        lienAnglais: "",
        auteur: "",
        annee: "",
        donneesProbantes: "",
        guideUtilisation: "",
        motsCles: "",
      });
    } catch (e) {
      alert("Erreur de sauvegarde");
    }
  };

  const handleImportCSV = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (event) => {
      const text = event.target.result;
      const rows = text.split("\n").slice(1);
      for (let row of rows) {
        const [titre, t1, t2, typo, pub, lang, desc, url, aut, an, prob, gui] =
          row.split(",").map((cell) => cell.replace(/^"(.*)"$/, "$1").trim());
        if (titre)
          await addDoc(collection(db, "ressources"), {
            titre,
            transition1: t1,
            transition2: t2,
            typologie: typo,
            publicCible: pub,
            langue: lang,
            description: desc,
            lien: url,
            auteur: aut,
            annee: an,
            donneesProbantes: prob,
            guideUtilisation: gui,
          });
      }
      window.location.reload();
    };
    reader.readAsText(file);
  };

  const filteredData = useMemo(() => {
    return data.filter((item) => {
      const rechercheNormalisee = normaliserTexte(searchQuery);

      const texteRecherche = normaliserTexte(
        [
          item.outilId,
          item.titre,
          item.auteur,
          item.annee,
          item.description,
          item.publicCible,
          item.typologie,
          item.transition1,
          item.transition2,
          item.langue,
          item.motsCles,
        ]
          .filter(Boolean)
          .join(" ")
      );

      const motsRecherches = rechercheNormalisee.split(/\s+/).filter(Boolean);

      const correspondanceId =
        rechercheNormalisee !== "" &&
        normaliserTexte(item.outilId) === rechercheNormalisee;

      const correspondanceTexte = motsRecherches.every((mot) =>
        texteRecherche.includes(mot)
      );

      const matchSearch =
        rechercheNormalisee === "" || correspondanceId || correspondanceTexte;
      const matchTrans =
        !transitionFilter ||
        item.transition1 === transitionFilter ||
        item.transition2 === transitionFilter;
      const matchTypo = !typologyFilter || item.typologie === typologyFilter;
      const matchPub = !publicFilter || item.publicCible === publicFilter;
      const matchLang =
        langueFilter.length === 0 ||
        langueFilter.some((langue) => item.langue?.includes(langue));
      return matchSearch && matchTrans && matchTypo && matchPub && matchLang;
    });
  }, [
    data,
    searchQuery,
    transitionFilter,
    typologyFilter,
    publicFilter,
    langueFilter,
  ]);

  if (isLoading)
    return (
      <div
        style={{
          padding: "50px",
          textAlign: "center",
          color: "#3f9ad3",
          fontSize: "1.2rem",
          fontWeight: "bold",
        }}
      >
        Initialisation du système...
      </div>
    );

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        padding: "2rem",
        fontFamily: "sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: "85rem",
          margin: "0 auto",
          backgroundColor: "#fff",
          padding: "3rem",
          borderRadius: "30px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
        }}
      >
        <header
          style={{
            marginBottom: "3rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          <div>
            <h1
              style={{
                color: "#3f9ad3",
                fontSize: "2.35rem",
                fontWeight: "bold",
                margin: "0 0 20px 0",
                lineHeight: "1.4",
              }}
            >
              Boîte à outils pour soutenir les transitions de soins des aînés
              <br />
              vivant avec un trouble de la mémoire et leurs proches
            </h1>
            <div
              style={{
                marginTop: "24px",
                marginBottom: "32px",
                padding: "24px 28px",
                border: "1px solid #d7e3ee",
                borderRadius: "18px",
                backgroundColor: "#f7fbff",
                maxWidth: "1200px",
              }}
            >
              <h2
                style={{
                  marginTop: 0,
                  marginBottom: "12px",
                  color: "#003b63",
                  fontSize: "24px",
                }}
              >
                Objectif
              </h2>

              <p
                style={{
                  margin: 0,
                  fontSize: "18px",
                  lineHeight: "1.6",
                  color: "#334155",
                }}
              >
                Cette boîte à outils présente les ressources recensées dans le
                cadre d’une cartographie systématique visant à identifier,
                décrire et classifier les outils qui soutiennent la prise de
                décision et la communication lors des transitions de soins des
                personnes âgées vivant avec un trouble neurocognitif majeur, de
                leurs proches aidants et des professionnels qui les
                accompagnent.
              </p>

              <a
                href="https://osf.io/g4sh9/overview"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  marginTop: "16px",
                  color: "#0072b8",
                  fontWeight: "700",
                  textDecoration: "underline",
                }}
              >
                Consulter le protocole ici
              </a>
            </div>
          </div>
          <a
            href="https://archambaultlab.ca/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={logoLab}
              alt="Logo Archambault Lab"
              style={{
                height: "130px",
                width: "auto",
                marginTop: "5px",
                cursor: "pointer",
              }}
            />
          </a>
        </header>
        <div
          style={{
            width: "100%",
            marginTop: "16px",
            marginBottom: "24px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "8px",
            }}
          >
            <button
              type="button"
              onClick={() => setShowCriteria(!showCriteria)}
              style={{
                padding: "7px 12px",
                border: "1px solid #2563eb",
                borderRadius: "6px",
                backgroundColor: "#ffffff",
                color: "#1d4ed8",
                fontSize: "13px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              {showCriteria
                ? "Masquer les critères d'inclusion et exclusion ▲"
                : "Afficher les critères d'inclusion et exclusion ▼"}
            </button>
          </div>

          {showCriteria && (
            <div
              style={{
                width: "100%",
                maxHeight: "360px",
                overflowY: "auto",
                border: "1px solid #cbd5e1",
                borderRadius: "6px",
                backgroundColor: "#ffffff",
                boxSizing: "border-box",
              }}
            >
              {/* POPULATION */}
              <div style={criteriaRowStyle}>
                <h3 style={criteriaCategoryStyle}>Population</h3>

                <div style={criteriaGridStyle}>
                  <div>
                    <h4 style={includeStyle}>Inclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>Personnes âgées.</li>
                      <li>Proches aidants.</li>
                      <li>
                        Professionnels de la santé et des services sociaux.
                      </li>
                      <li>Combinaison de ces catégories.</li>
                      <li>
                        Études pouvant être applicables aux personnes âgées,
                        notamment en contexte de maladie grave ou de fin de vie.
                      </li>
                    </ul>
                  </div>

                  <div>
                    <h4 style={excludeStyle}>Exclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>
                        Études dont les participants ne correspondent pas aux
                        populations ciblées.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* INTERVENTION */}
              <div style={criteriaRowStyle}>
                <h3 style={criteriaCategoryStyle}>
                  Intervention ou exposition
                </h3>

                <div style={criteriaGridStyle}>
                  <div>
                    <h4 style={includeStyle}>Inclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>
                        Outils d’aide à la décision : arbres décisionnels,
                        tableaux, guides, conseil décisionnel, clarification des
                        valeurs, planification préalable des soins et listes de
                        vérification.
                      </li>
                      <li>
                        Outils de soutien à la communication : journaux, carnets
                        de suivi et portails permettant aux usagers de
                        transmettre de l’information.
                      </li>
                      <li>
                        Systèmes et technologies : algorithmes, applications,
                        logiciels, cartes de parcours, plateformes
                        électroniques, agents conversationnels et portails de
                        télésanté bidirectionnels.
                      </li>
                      <li>
                        Outils de communication, de présentation et d’évaluation
                        des risques.
                      </li>
                      <li>Cadres éthiques et juridiques.</li>
                      <li>Programmes de développement professionnel.</li>
                    </ul>
                  </div>

                  <div>
                    <h4 style={excludeStyle}>Exclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>
                        Études ne décrivant, n’évaluant ou ne mettant pas en
                        œuvre un outil correspondant aux catégories ciblées.
                      </li>
                      <li>Dépliants ou feuillets d’information simples.</li>
                      <li>
                        Groupes de soutien sans outil décisionnel ou
                        communicationnel.
                      </li>
                      <li>
                        Dispositifs intelligents transmettant uniquement de
                        l’information de manière unidirectionnelle.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* CONTEXTE */}
              <div style={criteriaRowStyle}>
                <h3 style={criteriaCategoryStyle}>
                  Contexte et transitions de soins
                </h3>

                <div style={criteriaGridStyle}>
                  <div>
                    <h4 style={includeStyle}>Inclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>Transitions et navigation dans les soins.</li>
                      <li>Trajectoires de soins.</li>
                      <li>Planification préalable des soins.</li>
                      <li>Soins palliatifs et de fin de vie.</li>
                      <li>
                        Transition entre l’hôpital, le domicile et les soins de
                        longue durée.
                      </li>
                      <li>
                        Planification et coordination du congé hospitalier.
                      </li>
                      <li>Continuité des soins pendant une transition.</li>
                      <li>
                        Changements liés à l’évolution ou à l’aggravation de la
                        maladie.
                      </li>
                      <li>Orientation vers des ressources communautaires.</li>
                    </ul>
                  </div>

                  <div>
                    <h4 style={excludeStyle}>Exclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>
                        Études sans lien avec les transitions ou la navigation
                        dans les soins.
                      </li>
                      <li>
                        Essais cliniques portant principalement sur des
                        médicaments.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* PUBLICATIONS */}
              <div style={criteriaRowStyle}>
                <h3 style={criteriaCategoryStyle}>
                  Caractéristiques des publications
                </h3>

                <div style={criteriaGridStyle}>
                  <div>
                    <h4 style={includeStyle}>Inclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>Études primaires.</li>
                      <li>Revues systématiques et méta-analyses.</li>
                      <li>Guides de pratique.</li>
                      <li>Publications en français ou en anglais.</li>
                    </ul>
                  </div>

                  <div>
                    <h4 style={excludeStyle}>Exclusion</h4>
                    <ul style={criteriaListStyle}>
                      <li>Publications dans une autre langue.</li>
                      <li>Texte intégral non disponible.</li>
                      <li>Textes d’opinion et éditoriaux.</li>
                      <li>Résumés de conférences sans publication complète.</li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* DÉFINITION */}
              <div style={criteriaRowStyle}>
                <h3 style={criteriaCategoryStyle}>
                  Définition d’une transition de soins
                </h3>

                <div style={criteriaGridStyle}>
                  <div>
                    <h4 style={includeStyle}>Inclusion</h4>
                    <p style={criteriaTextStyle}>
                      Une transition de soins correspond aux changements
                      biopsychosociaux vécus par l’usager et ses proches à la
                      suite d’un diagnostic de trouble neurocognitif majeur.
                      Elle peut notamment survenir lors de l’annonce du
                      diagnostic, d’une référence, d’un changement de services,
                      de l’évolution de la maladie, d’une hospitalisation, d’un
                      congé ou du passage vers un milieu de soins de longue
                      durée.
                    </p>
                  </div>

                  <div>
                    <h4 style={excludeStyle}>Exclusion</h4>
                    <p style={criteriaTextStyle}>Sans objet.</p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            gap: "20px",
            marginBottom: "40px",
            flexWrap: "wrap",
          }}
        >
          <button
            hidden
            type="button"
            onClick={() => {
              setIsAdding(true);
              setEditingId(null);
            }}
            style={{
              backgroundColor: "#abd4ed",
              border: "none",
              padding: "12px 25px",
              borderRadius: "50px",
              fontWeight: "bold",
              color: "#3f9ad3",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Ajouter une ressource
          </button>

          <label
            style={{
              backgroundColor: "#f1f5f9",
              padding: "12px 25px",
              borderRadius: "50px",
              fontWeight: "bold",
              color: "#013a5d",
              cursor: "pointer",
              display: "none",
              alignItems: "center",
              gap: "8px",
            }}
          >
            Importer CSV
            <input
              type="file"
              accept=".csv"
              hidden
              onChange={handleImportCSV}
            />
          </label>
        </div>

        <div
          style={{
            display: "none",
            gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
            gap: "20px",
            backgroundColor: "#f8fafc",
            padding: "25px",
            borderRadius: "20px",
            border: "1px solid #e2e8f0",
            marginBottom: "3rem",
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "25px",
            alignItems: "end",
          }}
        >
          <div style={{ position: "relative" }}>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#013a5d",
              }}
            >
              Recherche
            </label>
            <SearchIcon />
            <input
              placeholder="ID, titre, auteur ou mot-clé..."
              style={{
                width: "100%",
                padding: "12px 12px 12px 45px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                boxSizing: "border-box",
                color: "#013a5d",
              }}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          <div>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#013a5d",
              }}
            >
              Type d'outil
            </label>
            <select
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                color: "#013a5d",
                backgroundColor: "#fff",
              }}
              value={typologyFilter}
              onChange={(e) => setTypologyFilter(e.target.value)}
            >
              <option value="">Tous</option>
              {typologiesOutils.map((t) => (
                <option key={t} value={t}>
                  {t}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#013a5d",
              }}
            >
              Transition
            </label>
            <select
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                color: "#013a5d",
                backgroundColor: "#fff",
              }}
              value={transitionFilter}
              onChange={(e) => setTransitionFilter(e.target.value)}
            >
              <option value="">Toutes</option>
              {categoriesTransitions.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#013a5d",
              }}
            >
              Public
            </label>
            <select
              style={{
                width: "100%",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                color: "#013a5d",
                backgroundColor: "#fff",
              }}
              value={publicFilter}
              onChange={(e) => setPublicFilter(e.target.value)}
            >
              <option value="">Tous</option>
              {publicsCibles.map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label
              style={{
                display: "block",
                fontWeight: "bold",
                fontSize: "0.95rem",
                marginBottom: "8px",
                color: "#013a5d",
              }}
            >
              Langue
            </label>
            <div style={{ position: "relative" }}>
              <button
                type="button"
                onClick={() => setShowLangueMenu(!showLangueMenu)}
                style={{
                  width: "100%",
                  padding: "12px",
                  borderRadius: "12px",
                  border: "1px solid #cbd5e1",
                  color: "#013a5d",
                  backgroundColor: "#fff",
                  textAlign: "left",
                  cursor: "pointer",
                }}
              >
                {langueFilter.length === 0
                  ? "Toutes"
                  : langueFilter.join(" + ")}{" "}
                ▼
              </button>

              {showLangueMenu && (
                <div
                  style={{
                    position: "absolute",
                    top: "48px",
                    left: 0,
                    right: 0,
                    backgroundColor: "#fff",
                    border: "1px solid #cbd5e1",
                    borderRadius: "12px",
                    padding: "12px",
                    zIndex: 10,
                    boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <label>
                    <input
                      type="checkbox"
                      checked={langueFilter.length === 0}
                      onChange={() => setLangueFilter([])}
                    />{" "}
                    Toutes
                  </label>

                  {["Français seulement", "Anglais seulement", "Bilingue"].map(
                    (l) => (
                      <label key={l}>
                        <input
                          type="checkbox"
                          checked={langueFilter.includes(l)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              setLangueFilter([...langueFilter, l]);
                            } else {
                              setLangueFilter(
                                langueFilter.filter((langue) => langue !== l)
                              );
                            }
                          }}
                        />{" "}
                        {l}
                      </label>
                    )
                  )}
                </div>
              )}
            </div>
          </div>
        </div>

        {(isAdding || editingId) && (
          <div
            style={{
              position: "relative",
              backgroundColor: "#ffffff",
              padding: "30px",
              borderRadius: "20px",
              border: "2px solid #3f9ad3",
              marginBottom: "40px",
            }}
          >
            <button
              onClick={() => {
                setIsAdding(false);
                setEditingId(null);
              }}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
            >
              <XIcon />
            </button>
            <h3 style={{ marginTop: 0, color: "#013a5d" }}>
              {editingId ? "Modifier la ressource" : "Ajouter une ressource"}
            </h3>
            <form
              onSubmit={handleSave}
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
              }}
            >
              <input
                placeholder="ID"
                value={formData.outilId || ""}
                onChange={(e) =>
                  setFormData({ ...formData, outilId: e.target.value })
                }
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
              />
              <input
                placeholder="Titre *"
                required
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.titre}
                onChange={(e) =>
                  setFormData({ ...formData, titre: e.target.value })
                }
              />
              <input
                placeholder="Auteur"
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.auteur}
                onChange={(e) =>
                  setFormData({ ...formData, auteur: e.target.value })
                }
              />
              <input
                placeholder="Année"
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.annee}
                onChange={(e) =>
                  setFormData({ ...formData, annee: e.target.value })
                }
              />
              <select
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.typologie}
                onChange={(e) =>
                  setFormData({ ...formData, typologie: e.target.value })
                }
              >
                <option value="">Typologie d'outil...</option>
                {typologiesOutils.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
              <select
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.transition1}
                onChange={(e) =>
                  setFormData({ ...formData, transition1: e.target.value })
                }
              >
                <option value="">Première transition...</option>
                {categoriesTransitions.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              <select
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.transition2}
                onChange={(e) =>
                  setFormData({ ...formData, transition2: e.target.value })
                }
              >
                <option value="">Seconde transition (facultatif)...</option>
                {categoriesTransitions.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </select>
              <select
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.publicCible}
                onChange={(e) =>
                  setFormData({ ...formData, publicCible: e.target.value })
                }
              >
                <option value="">Public cible...</option>
                {publicsCibles.map((p) => (
                  <option key={p} value={p}>
                    {p}
                  </option>
                ))}
              </select>
              <select
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.langue}
                onChange={(e) =>
                  setFormData({ ...formData, langue: e.target.value })
                }
              >
                <option value="">Langue...</option>
                {langues.map((l) => (
                  <option key={l} value={l}>
                    {l}
                  </option>
                ))}
              </select>
              <input
                placeholder="URL français"
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.lien}
                onChange={(e) =>
                  setFormData({ ...formData, lien: e.target.value })
                }
              />
              <input
                placeholder="URL anglais"
                value={formData.lienAnglais || ""}
                onChange={(e) =>
                  setFormData({ ...formData, lienAnglais: e.target.value })
                }
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
              />
              <input
                placeholder="Données probantes (URL)"
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.donneesProbantes}
                onChange={(e) =>
                  setFormData({ ...formData, donneesProbantes: e.target.value })
                }
              />
              <input
                placeholder="Guide d'utilisation (URL)"
                style={{
                  padding: "12px",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                }}
                value={formData.guideUtilisation}
                onChange={(e) =>
                  setFormData({ ...formData, guideUtilisation: e.target.value })
                }
              />
              <textarea
                placeholder="Mots-clés séparés par des virgules"
                style={{
                  padding: "12px",
                  gridColumn: "span 2",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                  minHeight: "70px",
                }}
                value={formData.motsCles || ""}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    motsCles: e.target.value,
                  })
                }
              />
              <textarea
                placeholder="Description"
                style={{
                  padding: "12px",
                  gridColumn: "span 2",
                  borderRadius: "10px",
                  border: "1px solid #cbd5e1",
                  minHeight: "80px",
                }}
                value={formData.description}
                onChange={(e) =>
                  setFormData({ ...formData, description: e.target.value })
                }
              />
              <button
                type="submit"
                style={{
                  backgroundColor: "#3f9ad3",
                  color: "white",
                  padding: "15px",
                  border: "none",
                  borderRadius: "50px",
                  fontWeight: "bold",
                  cursor: "pointer",
                  gridColumn: "span 2",
                  fontSize: "1rem",
                }}
              >
                {editingId ? "Mettre à jour" : "Sauvegarder la ressource"}
              </button>
            </form>
          </div>
        )}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
            gap: "30px",
          }}
        >
          {filteredData.map((item) => (
            <div
              key={item.id}
              style={{
                padding: "30px",
                borderRadius: "25px",
                border: "1px solid #e2e8f0",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                backgroundColor: "#fff",
                position: "relative",
                boxShadow: "0 4px 6px rgba(0,0,0,0.02)",
              }}
            >
              <div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    marginBottom: "15px",
                  }}
                >
                  <h3
                    style={{
                      color: "#3f9ad3",
                      margin: 0,
                      fontSize: "1.3rem",
                      fontWeight: "bold",
                    }}
                  >
                    {item.titre}
                  </h3>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <button
                      onClick={() => {
                        setEditingId(item.id);
                        setFormData(item);
                        setIsAdding(false);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "point0er",
                        display: "none",
                      }}
                    >
                      <EditIcon />
                    </button>
                    <button
                      onClick={async () => {
                        if (confirm("Supprimer cette ressource ?")) {
                          await deleteDoc(doc(db, "ressources", item.id));
                          setData(data.filter((i) => i.id !== item.id));
                        }
                      }}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        display: "none",
                      }}
                    >
                      <TrashIcon />
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    marginBottom: "15px",
                  }}
                >
                  <span
                    style={{
                      backgroundColor: "#f1f5f9",
                      color: "#013a5d",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "0.8rem",
                      fontWeight: "600",
                    }}
                  >
                    {item.langue}
                  </span>
                  {item.transition1 && (
                    <span
                      style={{
                        backgroundColor: "#e0f2fe",
                        color: "#0369a1",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                      }}
                    >
                      {item.transition1}
                    </span>
                  )}
                  {item.transition2 && (
                    <span
                      style={{
                        backgroundColor: "#e0f2fe",
                        color: "#0369a1",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "0.8rem",
                        fontWeight: "600",
                      }}
                    >
                      {item.transition2}
                    </span>
                  )}
                </div>

                <div
                  style={{
                    color: "#013a5d",
                    fontSize: "0.85rem",
                    marginBottom: "15px",
                    lineHeight: "1.5",
                  }}
                >
                  <p style={{ margin: "0 0 4px 0" }}>
                    <strong>Auteur :</strong> {item.auteur || "N/A"}{" "}
                    {item.annee ? `(${item.annee})` : ""}
                  </p>
                  <p style={{ margin: "0 0 4px 0" }}>
                    <strong>Type d'outil :</strong> {item.typologie}
                  </p>
                  <p style={{ margin: "0 0 4px 0" }}>
                    <strong>Public :</strong> {item.publicCible}
                  </p>
                  <p style={{ margin: "0 0 4px 0" }}>
                    <strong>ID :</strong> {item.outilId}
                  </p>
                </div>

                <p
                  style={{
                    fontSize: "0.95rem",
                    color: "#475569",
                    lineHeight: "1.6",
                    margin: "0 0 20px 0",
                  }}
                >
                  {item.description}
                </p>
              </div>

              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                {item.langue === "Bilingue" && item.lienAnglais ? (
                  <>
                    <button
                      type="button"
                      onClick={() =>
                        setOpenLangChoiceId(
                          openLangChoiceId === item.id ? null : item.id
                        )
                      }
                      style={{
                        flex: "1 1 100%",
                        textAlign: "center",
                        padding: "12px",
                        backgroundColor: "#3f9ad3",
                        borderRadius: "12px",
                        border: "none",
                        textDecoration: "none",
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "0.9rem",
                        marginBottom: "5px",
                        cursor: "pointer",
                      }}
                    >
                      Consulter
                    </button>

                    {openLangChoiceId === item.id && (
                      <>
                        <a
                          href={item.lien}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            flex: "1",
                            textAlign: "center",
                            padding: "12px",
                            backgroundColor: "#f1f5f9",
                            borderRadius: "12px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            color: "#013a5d",
                            fontSize: "0.9rem",
                            marginBottom: "5px",
                            border: "1px solid #cbd5e1",
                          }}
                        >
                          Français
                        </a>

                        <a
                          href={item.lienAnglais}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            flex: "1",
                            textAlign: "center",
                            padding: "12px",
                            backgroundColor: "#f1f5f9",
                            borderRadius: "12px",
                            textDecoration: "none",
                            fontWeight: "bold",
                            color: "#013a5d",
                            fontSize: "0.9rem",
                            marginBottom: "5px",
                            border: "1px solid #cbd5e1",
                          }}
                        >
                          Anglais
                        </a>
                      </>
                    )}
                  </>
                ) : (
                  <a
                    href={item.lien}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      flex: "1 1 100%",
                      textAlign: "center",
                      padding: "12px",
                      backgroundColor: "#3f9ad3",
                      borderRadius: "12px",
                      textDecoration: "none",
                      fontWeight: "bold",
                      color: "white",
                      fontSize: "0.9rem",
                      marginBottom: "5px",
                    }}
                  >
                    Consulter
                  </a>
                )}

                {item.donneesProbantes && (
                  <a
                    href={item.donneesProbantes}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      flex: "1",
                      textAlign: "center",
                      padding: "12px",
                      backgroundColor: "#f1f5f9",
                      borderRadius: "12px",
                      textDecoration: "none",
                      fontWeight: "bold",
                      color: "#013a5d",
                      fontSize: "0.85rem",
                      border: "1px solid #cbd5e1",
                    }}
                  >
                    Données probantes
                  </a>
                )}
                {item.guideUtilisation && (
                  <a
                    href={item.guideUtilisation}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      flex: "1",
                      textAlign: "center",
                      padding: "12px",
                      backgroundColor: "#f1f5f9",
                      borderRadius: "12px",
                      textDecoration: "none",
                      fontWeight: "bold",
                      color: "#013a5d",
                      fontSize: "0.85rem",
                      border: "1px solid #cbd5e1",
                    }}
                  >
                    Guide d'utilisation
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
